import { TLCLogger } from "../logger";
import { TLCEvents } from "../events/events";
import { TLC_CONSTANTS } from "../tlc-constants";

export class AbstractGenericPagedClientManager {
	constructor(config = {}) {
		const {resultsPanelId = ""} = config;

		var options = $.extend({
			searchEvent: TLC_CONSTANTS.Events.onClickSearch + resultsPanelId,
			prevPageEvent: TLC_CONSTANTS.Events.onClickPrevResultPage + resultsPanelId,
			nextPageEvent: TLC_CONSTANTS.Events.onClickNextResultPage + resultsPanelId,
			skipToPageEvent: TLC_CONSTANTS.Events.onClickSkipToResultPage + resultsPanelId,
			sortEvent: TLC_CONSTANTS.Events.onClickSortResults + resultsPanelId,
			responseEvent: TLC_CONSTANTS.Events.onPagingModelResponse + resultsPanelId,
			selectResultEvent: TLC_CONSTANTS.Events.onSelectResult + resultsPanelId,
			removeResultSelectionEvent: TLC_CONSTANTS.Events.onRemoveResultSelection + resultsPanelId,
			selectAllResultsEvent: TLC_CONSTANTS.Events.onSelectAll + resultsPanelId,
			removeAllSelectionsEvent: TLC_CONSTANTS.Events.onRemoveAllSelection + resultsPanelId,
			getSelectedResultsEvent: TLC_CONSTANTS.Events.onRequestSelectedResults + resultsPanelId,
			getSelectedResultsResponseEvent: TLC_CONSTANTS.Events.onSelectedResultsResponse + resultsPanelId,
			responsePropertyMap: {
				"totalHits": "totalHits"
			}
		}, config);

		this.pageSize = options.pageSize;
		this.resultsPanelId = options.resultsPanelId;

		//internal
		this.currentPage = 0;
		this.totalPages = null;
		this.pages = [];
		this.totalHits = 0;

		this.extraDataToPassBack = {};

		this.sortField = options.defaultSortField;//this should be optional
		this.sortDescending = options.defaultSortDesc;//this should be optional

		//optional
		this.responseEvent = options.responseEvent;
		this.prevPageEvent = options.prevPageEvent;
		this.nextPageEvent = options.nextPageEvent;
		this.skipToPageEvent = options.skipToPageEvent;
		this.sortEvent = options.sortEvent;
		this.searchEvent = options.searchEvent;
		this.selectResultEvent = options.selectResultEvent;
		this.removeResultSelectionEvent = options.removeResultSelectionEvent;
		this.selectAllResultsEvent = options.selectAllResultsEvent;
		this.removeAllSelectionsEvent = options.removeAllSelectionsEvent;
		this.getSelectedResultsEvent = options.getSelectedResultsEvent;
		this.getSelectedResultsResponseEvent = options.getSelectedResultsResponseEvent;

		this.prevPageEventGuid = TLCEvents.on(this.prevPageEvent, (event) => {
			this.getPrevPage(event);
		});

		this.nextPageEventGuid = TLCEvents.on(this.nextPageEvent, (event) => {
			this.getNextPage(event);
		});

		this.skipToPageEventGuid = TLCEvents.on(this.skipToPageEvent, (event) => {
			this.skipToPage(event);
		});


		//this should be optional
		this.sortEventGuid = TLCEvents.on(this.sortEvent, (event) => {
			this.sort(event);
		});

		this.selectResultEventGuid = TLCEvents.on(this.selectResultEvent, (event) => {
			this.pages[this.currentPage].results[event.index].selected = true;
			TLCEvents.trigger(this.getSelectedResultsResponseEvent, {
				results: this.getSelectedResults()
			});
		});


		this.removeResultSelectionEventGuid = TLCEvents.on(this.removeResultSelectionEvent, (event) => {
			this.pages[this.currentPage].results[event.index].selected = false;
			TLCEvents.trigger(this.getSelectedResultsResponseEvent, {
				results: this.getSelectedResults()
			});
		});


		this.selectAllResultsEventGuid = TLCEvents.on(this.selectAllResultsEvent, () => {
			//for each row in the current page, set selected = true
			$.each(this.pages[this.currentPage].results, function (i, result) {
				result.selected = true;
			});
			TLCEvents.trigger(this.getSelectedResultsResponseEvent, {
				results: this.getSelectedResults()
			});
		});

		this.removeAllSelectionsEventGuid = TLCEvents.on(this.removeAllSelectionsEvent, () => {
			$.each(this.pages[this.currentPage].results, function (i, result) {
				result.selected = false;
			});
			TLCEvents.trigger(this.getSelectedResultsResponseEvent, {
				results: this.getSelectedResults()
			});
		});

		this.getSelectedResultsEventGuid = TLCEvents.on(this.getSelectedResultsEvent, (event) => {
			TLCEvents.trigger(this.getSelectedResultsResponseEvent, {
				results: this.getSelectedResults()
			});
		});

	}

	removeListeners() {
		TLCEvents.off(this.sortEvent, this.sortEventGuid);
		TLCEvents.off(this.selectResultEvent, this.selectResultEventGuid);
		TLCEvents.off(this.removeResultSelectionEvent, this.removeResultSelectionEventGuid);
		TLCEvents.off(this.selectAllResultsEvent, this.selectAllResultsEventGuid);
		TLCEvents.off(this.removeAllSelectionsEvent, this.removeAllSelectionsEventGuid);
		TLCEvents.off(this.getSelectedResultsEvent, this.getSelectedResultsEventGuid);
		TLCEvents.off(this.nextPageEvent, this.nextPageEventGuid);
		TLCEvents.off(this.prevPageEvent, this.prevPageEventGuid);
		TLCEvents.off(this.skipToPageEvent, this.skipToPageEventGuid);
	}

	getSelectedResults() {
		if (this.isCurrent()) {
			var selectedResults = [];
			TLCLogger.log("this.pages");
			TLCLogger.log(this.pages);
			$.each(this.pages, function (i, foobar) {
				TLCLogger.log("page");
				TLCLogger.log(foobar);
				TLCLogger.log(i);
				if (foobar !== undefined) {
					var arr = $.grep(foobar.results, function (result, j) {
						return result.selected === true;
					});
					selectedResults = selectedResults.concat(arr);
				}
			});
			TLCLogger.log(selectedResults);
			return selectedResults;
		}
	}

	resetPageCache() {
		this.pages = [];
		this.totalHits = 0;
		this.currentPage = 0;
	}

	isCurrent() {
		return true;
	}

	getPrevPage(event) {
		if (this.isCurrent()) {
			event.oldPage = this.currentPage;
			this.currentPage--;
			this.getPage(event);
			this.addHistory(event);
		}
	}

	getNextPage(event) {
		if (this.isCurrent()) {
			event.oldPage = this.currentPage;
			this.currentPage++;
			this.getPage(event);
			this.addHistory(event);
		}
	}

	skipToPage(event) {
		if (this.isCurrent()) {
			event.oldPage = this.currentPage;
			this.currentPage = event.pageNum - 1;
			this.getPage(event);
			this.addHistory(event);
		}
	}

	sort(event) {
		if (this.isCurrent()) {
			if (this.sortField == event.sortField) {
				this.sortDescending = !this.sortDescending;
			}
			else {
				this.sortField = event.sortField;
				this.sortDescending = true;//TODO use the default sort order instead
			}
			this.pages = [];//clear page cache
			this.currentPage = 0;
			this.getPage(event);
		}
	}

	setPageSize( pageSize ) {
		if( this.pageSize == pageSize ) { return; }

		this.pageSize = pageSize;

		// because we're changing the page size, page 2 may not be the same anymore, so clear out.
		this.resetPageCache();
	}

	getPage(event) {
		if (this.isCurrent()) {
			if (this.pages[this.currentPage] === undefined) {
				TLCLogger.log("Fetching Page");
				this.fireSearch(event);
			}
			else {
				TLCLogger.log("Page Cached");
				this.successHandler(this.pages[this.currentPage]);
			}
		}
	}

	fireSearch() {
		this.search();
		TLCLogger.log("Override fireSearch function to pass search data you need");
		TLCLogger.log("ex: this.search(this.queryTokens, this.pageSize, this.currentPage, this.sortField, this.sortDescending);");
	}

	search() {
		throw("search must be overridden");
	}

	successHandler(data) {
		if (data.totalHits) {
			this.totalHits = data.totalHits;
		}

		this.pages[this.currentPage] = data;

		this.onSuccess(this.handleReturnData(data));
	}

	onSuccess(data) {
		TLCLogger.log("Paging Model Response:");
		TLCLogger.log(data);
		TLCEvents.trigger(this.responseEvent, {success: true, data: data});
	}

	handleReturnData(data) {
		var totalPages = Math.ceil(this.totalHits / this.pageSize);
		if (data.constructor.toString().indexOf("Array") != -1) {
			/* If the data is a List we need to convert it to a
			 property of an object to extend it with our paging data*/
			data = {serverResponse: data};
		}

		this.specialDataHandling(data);

		return $.extend(true, data, this.extraDataToPassBack, {
			currentPage: (totalPages > 0) ? this.currentPage + 1 : 0,
			sortField: this.sortField,
			sortDescending: this.sortDescending,
			totalPages: totalPages,
			prevEnabledClass: this.currentPage <= 0 ? 'disabled' : '',
			nextEnabledClass: this.currentPage + 1 < totalPages ? '' : 'disabled',
			prevEnabled: this.currentPage <= 0 ? false : true,
			nextEnabled: this.currentPage + 1 < totalPages ? true : false
		});
	}

	specialDataHandling(data) {
	}

	errorHandler(message, ex) {
		this.totalHits = 0;
		var data = this.handleReturnData({});
		TLCEvents.trigger(this.responseEvent, {success: false, data: data});
	}

	getResponseEvent() {
		return this.responseEvent;
	}

	addHistory() {
		TLCLogger.log("override PagedClientManager.addHistory");
	}

}